import React from 'react'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import Features from '../components/Features'
import Products from '../components/Products'
import Contact from '../components/Contact'
import Footer from '../components/Footer'

const Home = () => {
  return (
    <div data-component-path="client/src/pages/Home.jsx" data-component-line="10:5" data-component-id="client/src/pages/Home.jsx:10:5">
      <Navbar />
      <Hero />
      <Features />
      <Products />
      <Contact />
      <Footer />
    </div>
  )
}

export default Home